import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const webinarDetailsApi = createAsyncThunk(
    'auth/webinars/details',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.webinarsAction(`${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const webinarDetailsSlice = createSlice({
    name: 'webinar details',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetWebinar: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(webinarDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(webinarDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(webinarDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetWebinar } = webinarDetailsSlice.actions;
export const webinarDetailsReducer = webinarDetailsSlice.reducer